var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { FormHelperText } from '@mui/material';
import EditableInputWrapperV2 from '../../EditableInputWrapperV2';
import LabelWrapper from '../LabelWrapper';
import { RangeSlider } from '@leapfinance/geebee-component-library';
var Slider = function (_a) {
    var editable = _a.editable, displayValue = _a.displayValue, disabled = _a.disabled, label = _a.label, helperText = _a.helperText, valueProps = _a.value, _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 10 : _c, defaultValue = _a.defaultValue, rest = __rest(_a, ["editable", "displayValue", "disabled", "label", "helperText", "value", "min", "max", "defaultValue"]);
    var _d = __read(useState(valueProps !== null && valueProps !== void 0 ? valueProps : [min, max]), 2), value = _d[0], setValue = _d[1];
    useEffect(function () {
        if (typeof valueProps === 'undefined') {
            setValue([]);
        }
        else {
            setValue(valueProps);
        }
    }, [valueProps]);
    var handleSliderChange = function (event, value, activeThumb) {
        var _a;
        setValue(value);
        (_a = rest === null || rest === void 0 ? void 0 : rest.onChange) === null || _a === void 0 ? void 0 : _a.call(rest, event, value, activeThumb);
    };
    return React.createElement(RangeSlider, { enableLogScale: true, value: value, onChange: handleSliderChange, min: 0, max: 23000000 });
    return (React.createElement(LabelWrapper, { label: label, disabled: disabled },
        React.createElement(EditableInputWrapperV2, { editable: editable, value: displayValue === null || displayValue === void 0 ? void 0 : displayValue(value) },
            React.createElement(RangeSlider, __assign({ enableLogScale: true, value: value }, rest, { onChange: handleSliderChange, min: 0, max: 23000000 })),
            React.createElement(FormHelperText, null, helperText))));
};
export default Slider;
//# sourceMappingURL=Slider.js.map